import ApiClient from './ApiClient';

class Feedback extends ApiClient {
  constructor() {
    super('feedbacks', { accountScoped: true });
  }
}

export default new Feedback();
